import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from './locales/zh.json';
import vi from './locales/vi.json';
import th from './locales/th.json';
import mm from './locales/mm.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            zh: { translation: zh },
            vi: { translation: vi },
            th: { translation: th },
            mm: { translation: mm },
        },
        fallbackLng: 'zh',
        supportedLngs: ['zh', 'vi', 'th', 'mm'],
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

export default i18n;
